import { render, staticRenderFns } from "./LegislativeAffairsTable.vue?vue&type=template&id=2b3351a1&scoped=true&"
import script from "./LegislativeAffairsTable.vue?vue&type=script&lang=js&"
export * from "./LegislativeAffairsTable.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./LegislativeAffairsTable.vue?vue&type=style&index=1&id=2b3351a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3351a1",
  null
  
)

export default component.exports